
import { Coating, Commands, Entity, Events, eventsManager } from '@rhinov/savane-js';
import { InteractiveProjectHandler } from '../interactiveProjectHandler';
import { _ASSET_TYPE } from '@rhinov/asset-manager-service';


export class ReplaceCoatingCommand extends Commands.Command {
    
    private _handler: any;
    private _entity: any;
    private _toReplace: any;
    private isCredence: any;
    private _replaceBy: any;
    private _commands: any[];

    constructor(handler: InteractiveProjectHandler, entity: Entity, toReplace: Coating, replaceBy: Coating, isCredence: boolean) {
        super();

        this._handler = handler;
        this._entity = entity;
        this._toReplace = toReplace;
        this._replaceBy = replaceBy;

        this.isCredence = isCredence;

        // copy usemtlName
        this._replaceBy.usemtlName = this._toReplace.usemtlName;

        this._commands = [];
    }

    name = () : string => {
        return "ReplaceCoatingCommand";
    }

    assetType = () : _ASSET_TYPE => {
        return _ASSET_TYPE.COATINGS;
    }

    undo = () : void => {
        for (var i = 0; i < this._commands.length; ++i) {
            this._commands[i].undo();
        }

        var child = this._handler.scene.savaneScene.getDeepChild(this._entity.id);
        this._handler.scene.updateHull(child);
        if (this._replaceBy.floorGeneratorSettings || (this._toReplace && this._toReplace.floorGeneratorSettings) || this._entity.isGeometryPrimitiveEntity()) {
            eventsManager.instance.dispatch(Events.FLOOR_GENERATOR_CHANGED);
            eventsManager.instance.dispatch(Events.PROJECT_REFRESH_HULL);
        }

        eventsManager.instance.dispatch(Events.SELECTED_COATING, { entity: this._entity, coating: this._toReplace, isCredence: this.isCredence, point: null });
        eventsManager.instance.dispatch(Events.RHINOV_FORMAT_UPDATED, { scene: this._entity.scene, command: null });
    }

    redo = () : void => {
        this._exec(true);
    }

    execute = () : void => {
        this._exec(false);
    }

    _exec = (redo: boolean) : void => {
        this._commands = [];
        var child = this._handler.scene.savaneScene.getDeepChild(this._entity.id);
        if (this._toReplace.componentType) {
            this._replaceBy.rotation = this._toReplace.rotation;
            this._commands.push(new Commands.ReplaceComponentCommand(this._toReplace, this._replaceBy, this._entity));
        } else {
            this._commands.push(new Commands.AddComponentCommand(this._replaceBy, this._entity, false, false));
        }

        for (var i = 0; i < this._commands.length; ++i) {
            this._commands[i].execute();
        }

        this._handler.scene.updateHull(child);
        if (this._replaceBy.floorGeneratorSettings || (this._toReplace && this._toReplace.floorGeneratorSettings) || this._entity.isGeometryPrimitiveEntity()) {
            eventsManager.instance.dispatch(Events.FLOOR_GENERATOR_CHANGED);
            eventsManager.instance.dispatch(Events.PROJECT_REFRESH_HULL);
        }
        eventsManager.instance.dispatch(Events.SELECTED_COATING, { entity: this._entity, coating: this._replaceBy, isCredence: this.isCredence, point: null });
        eventsManager.instance.dispatch(Events.RHINOV_FORMAT_UPDATED, { scene: this._entity.scene, command: redo ? null : this });
    }

}
